// Copied from platform-app config/buttonTheme.ts on 2026-10-14 for Super Admin → POS Defaults — keep in step with the original.
// Mirrored in AGENTIC_POS/src/theme/buttonTheme.ts — change both; tests are identical.
import type { CSSProperties } from 'react';
import { BUTTON_REGISTRY, mergeButton, getButtonBgStyle, type ButtonOverride, type ButtonAppearance } from './buttonRegistry';

type PosTheme = 'light' | 'dark';

/** Theme-default tile colours. Keep in sync with --tile* tokens (index.css / tokens.ts). */
export const THEME_TILE: Record<PosTheme, { bg: string; bor: string; tx: string; destr: string; pos: string }> = {
  light: { bg: '#ffffff', bor: '#e4e4e7', tx: '#18181b', destr: '#b91c1c', pos: '#15803d' },
  dark:  { bg: '#1e1e22', bor: '#2a2a30', tx: '#f4f4f5', destr: '#f87171', pos: '#4ade80' },
};

/** Buttons whose theme default is red text/icon. */
export const DESTRUCTIVE_IDS: ReadonlySet<string> = new Set(['void', 'end-shift']);

const COLOUR_KEYS = ['bgColor', 'textColor', 'iconColor', 'bgType', 'gradientFrom', 'gradientTo', 'color'] as const;

/** True when the merchant saved any colour for this button in platform admin. */
export function hasUserColours(override?: ButtonOverride & { color?: string }): boolean {
  if (!override) return false;
  return COLOUR_KEYS.some((k) => (override as Record<string, unknown>)[k] !== undefined);
}

export function resolveButtonLook(
  actionId: string,
  override: (ButtonOverride & { color?: string }) | undefined,
  theme: PosTheme,
  tone: 'default' | 'destructive' | 'positive' = DESTRUCTIVE_IDS.has(actionId) ? 'destructive' : 'default',
  /** Defaults for a button outside BUTTON_REGISTRY (POS Header). Platform-app only. */
  registryEntry?: ButtonAppearance,
): { style: CSSProperties; fg: string } {
  if (hasUserColours(override)) {
    const merged = mergeButton(actionId, override, registryEntry) ?? { ...(registryEntry ?? BUTTON_REGISTRY[actionId]!) };
    return {
      style: { ...getButtonBgStyle(merged), color: merged.textColor, border: '1px solid transparent' },
      fg: merged.iconColor,
    };
  }
  const t = THEME_TILE[theme];
  const fg = tone === 'destructive' ? t.destr : tone === 'positive' ? t.pos : t.tx;
  return { style: { background: t.bg, color: fg, border: `1px solid ${t.bor}` }, fg };
}
